import { render, staticRenderFns } from "./GameHero.vue?vue&type=template&id=418c5259&scoped=true&"
import script from "./GameHero.vue?vue&type=script&lang=js&"
export * from "./GameHero.vue?vue&type=script&lang=js&"
import style0 from "./GameHero.vue?vue&type=style&index=0&id=418c5259&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c5259",
  null
  
)

export default component.exports